import { selectListingShareType } from '@app/components/ShareAttachmentModal/modules/shareAttachment'
import { PropertyType } from '@app/models/enums'
import { ApplicationState } from '@app/store'
import {
  IGlobalConfigurationState,
  selectConfiguration,
} from '@app/store/modules/global'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { createStructuredSelector } from 'reselect'
import MapViewPage from '../components/MapViewPage'
import {
  IMapViewState,
  selectIsLoading,
  selectProperties,
  selectError,
  selectTotalItems,
  selectListings,
  selectPropertyTypes,
  actionCreators,
  selectMarkerOption,
  selectListingStatus,
} from '../modules/mapView'

export default withRouter(
  connect(
    createStructuredSelector<
      ApplicationState,
      IGlobalConfigurationState & IMapViewState
    >({
      listingStatus: selectListingStatus(),
      propertyTypes: selectPropertyTypes(),
      isLoading: selectIsLoading(),
      properties: selectProperties(),
      listings: selectListings(),
      error: selectError(),
      totalItems: selectTotalItems(),
      markerOption: selectMarkerOption(),
      configuration: selectConfiguration(),
    }),
    actionCreators,
  )(MapViewPage),
)
